import React from "react"
import { Outlet } from "react-router-dom"
import { styled, Box } from "@mui/material"
import Div100vh from "react-div-100vh"

import { IAppLayoutProps } from "./interface"
import { IndoorMapContainer } from "containers/IndoorMapContainer"
import { SearchContainer } from "containers/SearchContainer"
import { NotificationContainer } from "containers/NotificationContainer"

const OutletWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
}))

const DEFAULT_SEARCH = <SearchContainer />

export const AppLayout: React.FC<IAppLayoutProps> = ({
  search = DEFAULT_SEARCH,
}) => {
  return (
    <Div100vh data-name="AppLayout">
      <IndoorMapContainer />
      <OutletWrapper>
        <Outlet />
      </OutletWrapper>
      {search || DEFAULT_SEARCH}
      <NotificationContainer />
    </Div100vh>
  )
}
